export default "__VITE_ASSET__508da0ce__"